declare namespace $ {

	export class $mol_icon_notebook_edit extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map